import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=a2d359a6&scoped=true&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=a2d359a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d359a6",
  null
  
)

export default component.exports